import React, { forwardRef } from 'react';
import clsx from 'clsx';

export const Input = forwardRef(({ label, error, helperText, className, ...props }, ref) => {
  return (
    <div className={className}>
      {label && <label className="label">{label}</label>}
      <input
        ref={ref}
        data-portica-role="input"
        className={clsx('input', error && 'input-error')}
        {...props}
      />
      {(error || helperText) && (
        <p className={clsx('mt-1 text-xs')} style={{ color: error ? 'var(--color-status-error-text)' : 'var(--color-text-secondary)' }}>
          {error || helperText}
        </p>
      )}
    </div>
  );
});

export const Textarea = forwardRef(({ label, error, helperText, className, rows = 3, ...props }, ref) => {
  return (
    <div className={className}>
      {label && <label className="label">{label}</label>}
      <textarea
        ref={ref}
        rows={rows}
        className={clsx('input resize-none', error && 'input-error')}
        {...props}
      />
      {(error || helperText) && (
        <p className={clsx('mt-1 text-xs')} style={{ color: error ? 'var(--color-status-error-text)' : 'var(--color-text-secondary)' }}>
          {error || helperText}
        </p>
      )}
    </div>
  );
});

export const Select = forwardRef(({ label, error, helperText, children, className, ...props }, ref) => {
  return (
    <div className={className}>
      {label && <label className="label">{label}</label>}
      <select
        ref={ref}
        className={clsx('input', error && 'input-error')}
        {...props}
      >
        {children}
      </select>
      {(error || helperText) && (
        <p className={clsx('mt-1 text-xs')} style={{ color: error ? 'var(--color-status-error-text)' : 'var(--color-text-secondary)' }}>
          {error || helperText}
        </p>
      )}
    </div>
  );
});

Input.displayName = 'Input';
Textarea.displayName = 'Textarea';
Select.displayName = 'Select';
